import { EquatorZonesService } from "./equator-zones.service";

export { EquatorZonesService };
